/***
 *
 *   POPUP STYLES
 *   The reference has no separate "popup" — it is a Dialog, so this shares the
 *   dialog surface from ui-reference/src/components/ui/dialog.tsx rather than
 *   the old fixed 50%x50% box, which clipped its own content.
 *
 **********/

const Style = {
    overlay: 'fixed inset-0 z-[996] bg-black/40 backdrop-blur-sm animate-fade-in',
    wrapper: 'pointer-events-none fixed inset-0 z-[997] flex items-center justify-center p-4',
    content: `pointer-events-auto relative max-h-[calc(100vh-2rem)] w-full max-w-lg overflow-y-auto rounded-xl border
    bg-surface-elevated p-6 text-center shadow-lg animate-scale-in`,
    top: 'flex flex-col items-center',
    title: 'text-lg font-semibold text-text-primary',
    divider: 'my-4 h-px w-full border-0 bg-border',
    text: 'text-sm text-text-secondary',
};

export default Style;
